module.exports = __webpack_public_path__ + "static/img/about_img_honour02.7fbef0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/guanyu/about_img_honour02.png
// module id = Hh3j
// module chunks = 1